import React from 'react';
import PropTypes from 'prop-types';

import MobileRow from './MobileRow';
import styles from './index.module.css';

const TableMobile = ({ withdrawals }) => (
  <div className={styles.tableMobile}>
    {withdrawals.map((withdrawal) => (
      <MobileRow key={withdrawal.id} withdrawal={withdrawal} />
    ))}
  </div>
);

TableMobile.propTypes = {
  withdrawals: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
    })
  ).isRequired,
};

export default TableMobile;
